import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API_URL_UTIL, BaseComponent } from 'src/app/@core/utils';
import { getFormattedDate } from 'src/app/@core/utils/date-format.utils';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs';
import { ApiResponse } from 'src/app/@shared/models';
import { EventTask } from 'src/app/@shared/models/user.modal';
import { SidebarModalService } from 'src/app/@shared/services/sidebar-modal.service'; import { AllCompanies, CompaniesListResponse, EmployeeListCompanwiseResponse, EmployeeListCompanyWise, HttpStatus } from 'src/app/@shared/models/add-employee.modal';
import { AddEmployeeService } from './add-employee.service';
import { StatusService } from 'src/app/@shared/services/status.service';
import { UserDataService } from 'src/app/@shared/services/user-data.service';
import { ToasterService } from 'src/app/@core/services';
import { ForemanService } from 'src/app/other shared services/foreman.service';

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.scss']
})
export class AddEmployeeComponent extends BaseComponent implements OnInit {
  selectedJobScheduleId!: string;
  selectedJob!: EventTask;
  removeResponseSession!: EmployeeListCompanyWise;
  modalButtonName = "Yes";
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  logInUser!: string;
  userSelectedJobId!: string;
  userSelectedEvent!: EventTask;
  selectedDate!: Date;
  maxSizePage = this.constants.addEmployee.addEmployeeMaxPageNo
  totalEmployee = 0;
  currentEmployeePageNo = 1;
  filterArray: Array<EmployeeListCompanyWise> = [];
  filteredString!: string;
  userAddedEmployee: Array<EmployeeListCompanyWise> = [];
  @Input() selectedEmployee!: Array<EmployeeListCompanyWise>;
  initialUserEmployee: Array<EmployeeListCompanyWise> = [];
  selectedCompany = 0;
  searchString = '';
  @Input() companyList!: Array<AllCompanies>;
  @Input() crewList!: Array<EmployeeListCompanyWise>;
  modalRef!: BsModalRef | undefined;
  constructor(
    private readonly addEmployeeService: AddEmployeeService,
    private readonly userDataService: UserDataService,
    private readonly toasterService: ToasterService,
    private readonly modalService: SidebarModalService,
    private readonly popupService: BsModalService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly foremanService: ForemanService,
    private readonly statusService: StatusService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.selectedEmployee) {
      const filter = this.selectedEmployee;
      this.selectedEmployee = [];
      filter.forEach(element => {
        if (element.employeeId) {
          element.jobSchedulePhaseID = null;
          this.selectedEmployee.push(element);
        }
      });
      this.userAddedEmployee = [...this.selectedEmployee];
      this.initialUserEmployee = [...this.userAddedEmployee];
    }
    this.getAllCompanies();
    this.getEmployeeList();
    this.getCurrentDetails();
  }

  getCurrentDetails(): void {
    this.logInUser = this.userDataService.getLoginUser();
    this.selectedJobScheduleId = this.activatedRoute.snapshot.queryParams.jobScheduleID;
    if (this.selectedJobScheduleId) {
      const selectedDate = this.activatedRoute.snapshot.queryParams.date;
      this.selectedDate = moment(selectedDate).toDate();
      this.getJobScheduleDetails(this.selectedJobScheduleId);
    }
  }

  getAllCompanies(): void {
    this.addEmployeeService.getAllCompanies().pipe(takeUntil(this.destroy$)).subscribe((allCompanies: CompaniesListResponse) => {
      this.companyList = allCompanies.data;
    })
  }

  getEmployeeList(): void {
    this.addEmployeeService.getEmplyeeList(this.selectedCompany, this.searchString, this.currentEmployeePageNo).pipe(takeUntil(this.destroy$)).subscribe((crewDetails: EmployeeListCompanwiseResponse) => {
      this.crewList = crewDetails.data.employeelistCompanwise;
      this.totalEmployee = crewDetails.data?.totalCount;
    })
  }

  addEmployeeInPhase(crew: EmployeeListCompanyWise): void {
    let check = false
    this.initialUserEmployee.forEach(element => {
      if (element.employeeId === crew.employeeId) {
        check = true;
      }
    });
    if (!check) {
      crew.jobSchedulePhaseID = "0";
      crew.worksFor = crew.companyId;
      this.userAddedEmployee.push(crew);
      this.initialUserEmployee.push(crew)
    }
  }

  removeEmployeeInPhase(crew: EmployeeListCompanyWise): void {
    const index = this.userAddedEmployee.indexOf(crew);
    this.userAddedEmployee.splice(index, 1);
    this.initialUserEmployee.splice(index, 1);
  }

  filterData(): void {
    this.userAddedEmployee = this.initialUserEmployee;
    this.userAddedEmployee = this.userAddedEmployee.filter(employee => {
      return employee.fullName?.toLocaleLowerCase()?.includes(this.filteredString?.toLowerCase())
    });
  }

  pageChanged(event: number): void {
    this.currentEmployeePageNo = event;
    this.getEmployeeList();
  }

  updateEmployee(): void {
    this.addEmployeeService.updateCrewDetails(this.selectedJobScheduleId, this.logInUser, this.initialUserEmployee, getFormattedDate(this.selectedDate)).pipe(takeUntil(this.destroy$)).subscribe({
      next: (employeeUpdate: HttpStatus) => {
        this.toasterService.success(employeeUpdate.message);
        this.onClose.emit(true);
        this.modalService.hideModal();
      },
      error: (employeeUpdate: HttpStatus) => {
        this.toasterService.error(employeeUpdate.message);
      }
    })
  }

  closeModal(): void {
    this.modalService.hideModal();
  }

  openModalWithComponent(showModal: TemplateRef<unknown>, data: EmployeeListCompanyWise) {
    this.modalRef = this.popupService.show(showModal);
    this.removeResponseSession = data;
  }

  modalResponse($event: boolean): void {
    if ($event) {
      this.removeEmployeeInPhase(this.removeResponseSession);
    }
  }

  getJobScheduleDetails(jobScheduleId: string): void {
    if (jobScheduleId) {
      this.foremanService.get<ApiResponse<EventTask>>(jobScheduleId, API_URL_UTIL.foreman.jobSchedule).pipe(takeUntil(this.destroy$)).subscribe(job => {
        this.statusService.updateStatus(job.data.jobCompleted);
        this.selectedJob = job.data;
      });
    }
  }
}
